"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signal_reachedDestination = exports.sendMessageRequest = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EJumpCommand = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMissionData_1 = require("@voyage/missions/voyageMissionData");
var voyageStarmapGenerator_sidecar_1 = require("@voyage/starmap/voyageStarmapGenerator-sidecar");
var voyageGameMode_game_director_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_director-sidecar");
var voyageGameMode_game_hyperspace_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_hyperspace-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var EJumpCommand;
(function (EJumpCommand) {
    EJumpCommand[EJumpCommand["Request"] = 1] = "Request";
    EJumpCommand[EJumpCommand["Engage"] = 2] = "Engage";
    EJumpCommand[EJumpCommand["ReachDestination"] = 3] = "ReachDestination";
})(EJumpCommand = exports.EJumpCommand || (exports.EJumpCommand = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Jump;
var _destination = null;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.command);
    messageWriter_sidecar_1.messageWriter.write16(m, d.i);
    messageWriter_sidecar_1.messageWriter.write16(m, d.j);
    // messageWriter.writeBool(m, d.isStarbase)
    messageWriter_sidecar_1.messageWriter.writeString(m, d.locationName);
    messageWriter_sidecar_1.messageWriter.write8(m, d.missionType);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        command: messageWriter_sidecar_1.messageWriter.read8(m),
        i: messageWriter_sidecar_1.messageWriter.read16(m),
        j: messageWriter_sidecar_1.messageWriter.read16(m),
        //isStarbase: messageWriter.readBool(m),
        locationName: messageWriter_sidecar_1.messageWriter.readString(m),
        missionType: messageWriter_sidecar_1.messageWriter.read8(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        command: EJumpCommand.Engage,
        // isStarbase: true,
        i: 10,
        j: 1021,
        locationName: 'somewhere',
        missionType: voyageMissionData_1.EVoyageMissionType.SurveyAnomaly,
    };
    messageWriter_sidecar_1.messageWriter.test('jump', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    // diveCrew.networkHurt(msg)
    if (msg.command === EJumpCommand.Request) {
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            var status_1 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
            if (status_1.jumpCharge >= 95) {
                sendMessageAndImmediatelyExecute({
                    command: EJumpCommand.Engage,
                    i: msg.i,
                    j: msg.j,
                    // isStarbase: msg.isStarbase,
                    locationName: msg.locationName,
                    missionType: msg.missionType,
                });
            }
        }
    }
    if (msg.command === EJumpCommand.Engage) {
        var status_2 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        status_2.addJumpCharge += -100;
        status_2.isAtStarbase = false;
        status_2.locationName = 'Hyperspace';
        voyageStarmapGenerator_sidecar_1.voyageStarmapGenerator.travelTowards(msg.i, msg.j);
        voyageGameStatus_sidecar_1.voyageGameStatus.setMission(voyageMissionData_1.EVoyageMissionType.Hyperspace);
        voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.signalHyperspace();
        _destination = msg;
    }
    if (msg.command === EJumpCommand.ReachDestination) {
        var status_3 = voyageGameStatus_sidecar_1.voyageGameStatus.get();
        status_3.isAtStarbase = msg.missionType === voyageMissionData_1.EVoyageMissionType.Starbase;
        status_3.locationName = msg.locationName;
        voyageStarmapGenerator_sidecar_1.voyageStarmapGenerator.travelTo(msg.i, msg.j, true);
        voyageGameStatus_sidecar_1.voyageGameStatus.setMission(msg.missionType);
        // TODO: exit hyperspace ??
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            voyageGameMode_game_director_sidecar_1.voyageGameMode_game_director.signalAction();
        }
    }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageRequest(msg) {
    websockets_sidecar_1.websockets._sendMessageRequest(write, msg);
}
exports.sendMessageRequest = sendMessageRequest;
function signal_reachedDestination() {
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        assert_sidecar_1.assert.notNil(_destination);
        sendMessageAndImmediatelyExecute({
            command: EJumpCommand.ReachDestination,
            i: _destination.i,
            j: _destination.j,
            locationName: _destination.locationName,
            missionType: _destination.missionType,
        });
    }
}
exports.signal_reachedDestination = signal_reachedDestination;
